<template>
  <div class="edit-modal-wrap">
    <el-dialog
      :close-on-click-modal="false"
      :title="isEdit ? '查看转化归因' : '新建转化归因'"
      :visible.sync="dialogVisible"
      width="688px"
      @closed="modalClosed"
      @open="initSelect"
    >
      <div class="modal-body">
        <div class="form-content">
          <el-form :rules="rules" ref="formRef" :model="formData" label-width="115px">
            <el-form-item prop="accountId">
              <span slot="label"> <span style="color: red">*</span> 广告账号 :</span>
              <el-select
                :disabled="isEdit"
                style="width: 100%"
                v-model="formData.accountId"
                filterable
              >
                <el-option
                  v-for="item of countList"
                  :key="item.advertiserId"
                  :value="item.advertiserId"
                  :label="item.company + '-' + item.advertiserId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="conversionName">
              <span slot="label"> <span style="color: red">*</span> 转化归因 :</span>
              <el-input
                :disabled="isEdit"
                v-model="formData.conversionName"
                placeholder="请输入转化归因"
                maxlength="120"
                show-word-limit
              ></el-input>
            </el-form-item>
            <el-form-item prop="conversionName">
              <span slot="label"> <span style="color: red">*</span> 上报方式 :</span>
              API上报
            </el-form-item>
            <el-form-item prop="promotedObjectId" v-if="formData.accountId">
              <span slot="label"> <span style="color: red">*</span> 推广目标 :</span>
              <el-select
                filterable
                popper-class="edit-gdt-convert-select"
                :disabled="isEdit"
                style="width: 100%"
                v-model="formData.promotedObjectId"
              >
                <el-option
                  style="margin-bottom: 6px"
                  v-for="item in promotedList"
                  :key="item.promotedObjectId"
                  :value="item.promotedObjectId"
                  :label="item.promotedObjectName + '(' + item.promotedObjectId + ')'"
                >
                  <div class="seitem-wrap">
                    <div class="img-wrap">
                      <img class="app-img" :src="item.iconUrl" />
                    </div>
                    <div class="seitem-content">
                      <span class="app-detail">{{ item.promotedObjectName }}</span>
                      <span class="app-detail">({{ item.promotedObjectId }})</span>
                    </div>
                    <svg-icon
                      :iconClass="
                        item.promotedObjectType === 'APP_ANDROID'
                          ? 'android'
                          : item.promotedObjectType === 'APP_IOS'
                          ? 'apple'
                          : ''
                      "
                      className="os-icon"
                    ></svg-icon>
                  </div>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="claimType">
              <span slot="label"> <span style="color: red">*</span> 归因方式 :</span>
              <el-radio-group v-model="formData.claimType" size="small" :disabled="isEdit">
                <el-radio-button label="CLAIM_TYPE_CLICK">点击归因</el-radio-button>
                <el-radio-button label="CLAIM_TYPE_ACTIVATION">激活归因</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item prop="feedbackUrl">
              <span slot="label"> <span style="color: red">*</span> 监控链接 :</span>
              <el-input
                :disabled="isEdit"
                v-model="formData.feedbackUrl"
                placeholder="请输入监控链接"
              ></el-input>
            </el-form-item>
            <el-form-item prop="optimizationGoal" v-if="formData.promotedObjectId">
              <span slot="label"> <span style="color: red">*</span> 优化目标类型 :</span>
              <el-select :disabled="isEdit" style="width: 100%" v-model="formData.optimizationGoal">
                <el-option
                  v-for="item in optimizationGoalList"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="deepType" v-if="formData.optimizationGoal">
              <span slot="label">深度优化目标 :</span>
              <el-radio-group v-model="formData.deepType" size="small" :disabled="isEdit">
                <el-radio-button :label="null">不限</el-radio-button>
                <el-radio-button :label="1">行为</el-radio-button>
                <el-radio-button :label="2">ROI</el-radio-button>
              </el-radio-group>
              <el-select
                v-if="formData.deepType"
                :disabled="isEdit"
                style="width: 100%"
                v-model="formData.deepOptimizationGoal"
              >
                <el-option
                  v-for="item in deepBehaviorOptionsIObj[formData.optimizationGoal] || []"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="footer-wrap">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button @click="submitData" type="primary" v-show="!isEdit">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import SvgIcon from "@/components/SvgIcon.vue";
import { transferActionList } from "../../../../promotion-gdt/subPlan/common/config";
import {
  getAdCount,
  getPromotedAppList,
  getOptimizationGoal,
  createConvert_gdt,
} from "@/api/property.js";
import { getCommonProductList } from "@/api/api.js";
import { goalRoiList } from "./config";
export default {
  components: {
    SvgIcon,
  },
  data() {
    return {
      transferActionList,
      goalRoiList,
      isEdit: false,
      dialogVisible: false,
      countList: [],
      appList: [],
      promotedList: [],
      optimizationGoalList: [],
      deepBehaviorListObj: {},
      deepWorthOptimizationGoalListOBj: {},
      deepBehaviorOptions: [],
      formData: {
        accountId: null,
        conversionName: "",
        promotedObjectId: null,
        claimType: "CLICK",
        optimizationGoal: null,
        feedbackUrl: "",
        deepType: null,
        deepOptimizationGoal: null,
        accessType: "ACCESS_TYPE_API",
      },
      rules: {
        accountId: [{ required: true, message: "请选择广告账号", trigger: "change" }],
        conversionName: [{ required: true, message: "请输入转化名称", trigger: "change" }],
        promotedObjectId: [{ required: true, message: "请选择推广目标", trigger: "change" }],
        optimizationGoal: [{ required: true, message: "请输入深度转化目标", trigger: "change" }],
        feedbackUrl: [
          { required: true, message: "请输入点击监测链接", trigger: "change" },
          { validator: this.linkCheck, trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    addTransform() {
      this.isEdit = false;
      this.dialogVisible = true;
      this.formData = {
        accountId: null,
        conversionName: "",
        promotedObjectId: null,
        claimType: "CLICK",
        optimizationGoal: null,
        feedbackUrl: "",
        deepType: null,
        deepOptimizationGoal: null,
        accessType: "ACCESS_TYPE_API",
      };
    },
    async checkTransform(data) {
      const {
        advertiserId,
        name,
        appId,
        claimType,
        deepExternalAction,
        actionTrackUrl,
        convertType,
        convertSourceType,
        deepType,
      } = data;
      await getPromotedAppList({
        accountIds: [advertiserId],
      }).then((res) => {
        this.promotedList = res.data;
      });
      this.formData.promotedObjectId = appId;
      this.formData.accountId = advertiserId;
      this.formData.conversionName = name;
      this.formData.claimType = claimType;
      this.formData.optimizationGoal = convertType;
      this.formData.deepType = deepType;
      this.formData.feedbackUrl = actionTrackUrl;
      this.formData.deepOptimizationGoal = deepExternalAction;
      this.formData.accessType = convertSourceType;
      this.isEdit = true;
      this.dialogVisible = true;
    },
    initSelect() {
      getAdCount({ platType: 2 }).then((res) => {
        if (res.code === "0000") {
          this.countList = res.advertiseInfos;
        }
      });
      getCommonProductList({
        platType: 2,
      }).then((res) => {
        if (res.code === "0000") {
          this.appList = res.data;
        }
      });
    },
    submitData() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          const data = JSON.parse(JSON.stringify(this.formData));
          data.promotedObjectType = this.promotedList.find(
            (item) => item.promotedObjectId === data.promotedObjectId
          ).promotedObjectType;
          createConvert_gdt(data).then((res) => {
            if (res.code === "0000") {
              this.dialogVisible = false;
              this.$message({
                message: "新增应用转化成功",
                type: "success",
              });
              this.$emit("refreshList");
            }
          });
        }
      });
    },
    modalClosed() {
      this.$refs.formRef.resetFields();
    },
    linkCheck(rule, value, callback) {
      if (!/^https:\/\/.+\..+/.test(value)) {
        callback(new Error("请输入正确的https协议链接"));
      } else {
        callback();
      }
    },
  },
  watch: {
    "formData.accountId": {
      handler(val) {
        if (val) {
          getPromotedAppList({
            accountIds: [val],
          }).then((res) => {
            if (!this.isEdit) {
              this.formData.promotedObjectId = "";
            }
            this.promotedList = res.data;
          });
        }
      },
      deep: true,
    },
    "formData.promotedObjectId": {
      handler(val) {
        if (val) {
          console.log();
          getOptimizationGoal({
            accountId: this.formData.accountId,
            promotedObjectType: this.promotedList.find((item) => item.promotedObjectId === val)
              .promotedObjectType,
          }).then((res) => {
            const {
              optimizationGoalPermissionList,
              deepBehaviorOptimizationGoalPermissionList,
              deepWorthOptimizationGoalPermissionList,
            } = res.data;
            this.optimizationGoalList = this.transferActionList.filter((item) =>
              optimizationGoalPermissionList.includes(item.value)
            );
            deepBehaviorOptimizationGoalPermissionList.map((child) => {
              this.deepBehaviorListObj["OPTIMIZATIONGOAL_" + child.optimizationGoal] =
                this.transferActionList.filter((item) =>
                  child.deepBehaviorOptimizationGoalList.includes(item.value)
                );
            });
            deepWorthOptimizationGoalPermissionList.map((child) => {
              this.deepWorthOptimizationGoalListOBj["OPTIMIZATIONGOAL_" + child.optimizationGoal] =
                this.goalRoiList.filter((item) =>
                  child.deepWorthOptimizationGoalList.includes(item.value)
                );
            });
          });
        }
      },
      deep: true,
    },
    "formData.deepType": {
      handler(val) {
        if (val) {
          this.formData.deepOptimizationGoal = "";
          this.deepBehaviorOptionsIObj =
            val === 1 ? this.deepBehaviorListObj : this.deepWorthOptimizationGoalListOBj;
        }
      },
      deep: true,
    },
    "formData.optimizationGoal": {
      handler(val) {
        if (val) {
          this.formData.deepOptimizationGoal = "";
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="less" scoped>
.modal-body {
  .form-content {
    /deep/ .el-radio__input.is-checked .el-radio__inner {
      color: rgba(24, 144, 255, 1);
      border-color: rgba(24, 144, 255, 1);
      background: rgba(24, 144, 255, 1);
    }
    /deep/ .el-radio__input.is-checked + .el-radio__label {
      color: rgba(24, 144, 255, 1);
    }
  }
  .footer-wrap {
    text-align: right;
    padding-bottom: 24px;
  }
}
</style>
<style lang="less">
.edit-gdt-convert-select {
  .el-scrollbar {
    display: block !important;
  }
  .seitem-wrap {
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0px;
    box-sizing: border-box;
    .img-wrap {
      width: 30px;
      height: 30px;
      margin-right: 10px;
      .app-img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .seitem-content {
      font-size: 12px;
      .app-detail {
        display: block;
        line-height: 16px;
      }
    }
    .os-icon {
      margin: 0 0px 0 auto;
      font-size: 18px;
    }
  }
}
</style>
